import moment from "moment";
import { BlockHour } from "types/models";

/** Raw item from GET appointment/blockHours → payload[]. */
interface RawBlockHour {
  // block-hour rows always carry their primary key (consumers call id.toString())
  id: number | string;
  staffId?: number | string;
  startTime: string; // 'MM/DD/YYYY HH:mm A'
  endTime: string;
  reason?: string;
}

const mappingBlockHour = (blockHourItems: RawBlockHour[]): BlockHour[] => {
  const data = blockHourItems.map((o): BlockHour => {
    const id = o.id?.toString();
    const staffId = o.staffId?.toString();
    const startTime = moment(o.startTime, 'MM/DD/YYYY HH:mm A').format('MM-DD-YYYY HH:mm:ss');
    const endTime = moment(o.endTime, 'MM/DD/YYYY HH:mm A').format('MM-DD-YYYY HH:mm:ss');
    return ({
      id,
      type: 'block-hour',
      data: {
        id,
        staffId, startTime, endTime,
        note: o.reason || '',
      },
      staffId, startTime, endTime,
    });
  });
  return data;
};

export default mappingBlockHour;
